// TODO - Documentar
// Selected Lines Hook

import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import * as con from "../../GlobalConstants"

export const UserLinesHook = () =>
{
    const lines = useSelector((state) => state[con.REDUCER_USER_LINES][con.LINES])
    return(lines)
}


export const StaffUserLineComments = (userLineId) =>
{
    const allComments = useSelector((state) => state[con.REDUCER_ADMIN_LINE_COMMENTS])
    
    const [userLineComments, setUserLineComments] = useState(() => [])


    useEffect(() => {
        setUserLineComments(allComments.filter(com => `${com[con.USER_LINE]}` === `${userLineId}`))
    }, [allComments, userLineId])
    
    return(userLineComments)
}

/**
 * Hook for a single model parameter in the store read only
 */
export function RefUserLinesHook(parameterName) {

    const value = useSelector(state => state[con.REDUCER_USER_LINES][parameterName])


    return(value);
}
